import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/Loader";
import { useState } from "react";
import SliderArray from "./SliderArray";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { editPageSections, getAllPageSections } from "store/actions";
import { useNavigate } from "react-router-dom";

export default function SeoData() {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, sections } = useSelector((state) => state.section);
  // const sections = useMemo(
  //   () =>
  //     Object.entries(sections?.content || {}).map(([key, value], id) => ({
  //       ...value,
  //       id,
  //     })),
  //   [sections]
  // );

  const { handleSubmit } = useForm();
  const [sliders, setSliders] = useState(sections);

  // get single page by slug
  useEffect(() => {
    dispatch(getAllPageSections("seo-data"));
  }, [dispatch]);

  useEffect(() => {
    if (sections?.length > 0)
      setSliders(
        sections?.map((item, index) => ({
          ...item,
          id: index,
        })) || [],
      );
    // reset(sections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sections]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    // let index = 0;
    // data.sections = sliders;
    // .reduce((result, current) => {
    //   // const key = Object.keys(current)[0];
    //   result[`section${index}`] = current;
    //   index++;
    //   return result;
    // }, {});
    dispatch(
      editPageSections({
        page: "seo-data",
        data: { sections: sliders },
        navigate,
      }),
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="seoData" />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col>
                <Row>
                  <Col lg={12}>
                    <SliderArray sliders={sliders} setSliders={setSliders} />
                  </Col>
                </Row>

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
